<template>
    <div class="tool-bar">
        <div style="width: auto;">楼层序号<span v-if="viewIndex + 1 <= 9">0{{ viewIndex + 1 }}</span><span v-else>{{ viewIndex +
            1
        }}</span></div>
        <div style="display: flex;flex: 1;justify-content: flex-end;position: relative">
            <!-- <div class="bar-item" v-if="viewIndex < viewlist.length - 1" @click="toDown(viewIndex)">
                <img src="../assets/icon_xia@2x.png" alt="" class="bar-img">
                <span>下移</span>
            </div>
            <div class="bar-item" v-if="viewIndex > 0" @click="toUp(viewIndex)">
                <img src="../assets/icon_shang@2x.png" alt="" class="bar-img">
                <span>上移</span>
            </div>
            <div class="bar-item" @click="toEdit(viewIndex)">
                <img src="../assets/icon_bianji@2x.png" alt="" class="bar-img">
                <span>编辑</span>
            </div>
            <div class="bar-item" @click="toDel(viewIndex)">
                <img src="../assets/icon_shanchu@2x.png" alt="" class="bar-img">
                <span>删除</span>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    name: 'toolBar',
    props: {
        viewlist: {
            type: Array,
            default: () => []
        },
        viewIndex: {
            type: Number,
            default: () => 0
        }
    },
    methods: {
        toDown(idx) {
            this.$emit('toDown', idx)
        },
        toUp(idx) {
            this.$emit('toUp', idx)
        },
        toEdit(idx) {
            this.$emit('toEdit', idx)
        },
        toDel(idx) {
            this.$emit('toDel', idx)
        }
    }
}
</script>
<style>
.tool-bar {
    width: 100%;
    height: 31px;
    background-color: rgba(0, 0, 0, 0.4);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 0 8px;
    box-sizing: border-box;
    justify-content: space-between;
    font-size: 14px;
    color: white;
    z-index: 11;
    overflow-x: visible;
    /* display: none; */
}

.bar-item {
    display: flex;
    align-items: center;
    margin-left: 14px;
    cursor: pointer;
}

.bar-img {
    width: 18px;
    height: 18px;
}
</style>